import React, { useEffect } from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
        <video className='hero-vid' />
        <h1>KICKSTART THE JOURNEY INTO STEM.</h1>
        <p>Personalized Robotics and Coding Classes, Tailored to You.</p>
        <div className="hero-btns">
            <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            navigate='/programme'
            >
            PROGRAMME
            </Button>
            <Button
            className='btns'
            buttonStyle='btn--primary'
            buttonSize='btn--large'
            onClick={() => {
              const videoElement = document.getElementById('video');
              if (videoElement) {
                videoElement.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            >
            WATCH INTRO <i className='far fa-play-circle' />
            </Button>
        </div>
    </div>
  )
}

export default HeroSection
